import authService from '../components/api-authorization/AuthorizeService'

export const SiguienteTurno = async (boxAtencionID) => {
    const token = await authService.getAccessToken();
    const response = await fetch('api/TurnosPorBox/SiguienteTurno/' + boxAtencionID, {
        method: "POST",
        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    
    if (response.status === 401) {
        await authService.signIn();
    }

    const data = await response;
    // console.log(data);
    return data;
}